<template>
  <b-row>
    <b-col>
      <b-tabs>
        <b-tab :title="uniTranslation('TRNSL221')" active lazy
          ><PlatePricesManagement></PlatePricesManagement
        ></b-tab>
        <b-tab :title="uniTranslation('TRNSL222')" lazy
          ><p><FramePricesManagement></FramePricesManagement></p
        ></b-tab>
        <b-tab :title="uniTranslation('TRNSL223')" lazy>
          <p><GasketPricesManagement></GasketPricesManagement></p>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PlatePricesManagement from "./PlatePricesManagement";
import GasketPricesManagement from "./GasketPricesManagement";
import FramePricesManagement from "./FramePricesManagement";
export default {
  components: {
    PlatePricesManagement,
    GasketPricesManagement,
    FramePricesManagement
  },
  props: {},
  data() {
    return {
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      coloreTitolo: "",
      coloreBarraTitolo: ""
    };
  },
  computed: {
    ...mapGetters("_colorsModule", ["cardColors"])
  },
  watch: {},
  mounted: function() {
    var that = this;

    that.coloreSfondo = that.cardColors[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
    that.coloreBarraTitolo = that.cardColors[1];
    that.coloreTesto = that.cardColors[2];
    that.coloreTitolo = that.cardColors[3];
    that.coloreBordo = that.cardColors[6];
  },
  methods: {}
};
</script>

<style lang="scss">
.card .card-header {
  color: transparent;
  background-color: transparent;
  padding: 0px;
}
</style>
